import { render, staticRenderFns } from "./currency.vue?vue&type=template&id=ca71f1ac&scoped=true"
import script from "./currency.vue?vue&type=script&lang=js"
export * from "./currency.vue?vue&type=script&lang=js"
import style0 from "./currency.vue?vue&type=style&index=0&id=ca71f1ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca71f1ac",
  null
  
)

export default component.exports